"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Serie = void 0;
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
class Serie {
    get id() {
        return this.model.Id;
    }
    set id(value) {
        this.model.Id = value;
    }
    get bezeichnungKurz() {
        return this.model.BezeichnungKurz;
    }
    set bezeichnungKurz(value) {
        this.model.BezeichnungKurz = value;
    }
    get kurzbezeichnung() {
        return this.model.Kurzbezeichnung;
    }
    set kurzbezeichnung(value) {
        this.model.Kurzbezeichnung = value;
    }
    get bezeichnung() {
        return this.model.Bezeichnung;
    }
    set bezeichnung(value) {
        this.model.Bezeichnung = value;
    }
    constructor(model) {
        this.model = model;
    }
    is(that) {
        return this.id === that.id;
    }
    hasEqualValues(that, comparator) {
        if (comparator)
            return comparator(this, that);
        const thisJson = this.toJson();
        const thatJson = that.toJson();
        return (0, echain_shared_ts_utils_1.deepEqual)(thisJson, thatJson);
    }
    fromJson(json) {
        this.model = Object.assign(Object.assign({}, this.model), json);
    }
    toJson() {
        return Object.assign({}, this.model);
    }
}
exports.Serie = Serie;
//# sourceMappingURL=Serie.js.map